import { render, staticRenderFns } from "./closureTemplates.vue?vue&type=template&id=66a52df9"
import script from "./closureTemplates.vue?vue&type=script&lang=js"
export * from "./closureTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports